import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';
import { userHasFn, SUB_APPS } from '../../utils/rbac';
import SubAppHeaderActions from '../../components/SubAppHeaderActions';

const navClass = ({ isActive }) =>
  `nav-link ${isActive ? 'active fw-semibold' : ''}`;

function InventoryLayout() {
  const { user } = useContext(AuthContext);
  const canAdmin = userHasFn(user, SUB_APPS.INVENTORY, 'admin');

  return (
    <div className="container-fluid mt-3 px-3 app-shell-page sub-app-white-nav inventory-app">
      <div className="card app-card bg-white mb-3">
        <div className="card-body py-3">
          <div className="app-layout-bar d-flex flex-wrap justify-content-between align-items-center gap-2 mb-0 pb-0">
            <h1 className="app-layout-title mb-0">Inventory</h1>
            <SubAppHeaderActions
              subAppHomePath={ROUTES.INVENTORY}
              subAppHomeLabel="Inventory"
              navButtonClassName="btn btn-sm bg-white text-dark border"
            />
          </div>

          <ul className="nav nav-tabs mb-0 mt-3">
            <li className="nav-item">
              <NavLink to={ROUTES.INVENTORY} end className={navClass}>
                Inventory
              </NavLink>
            </li>
            {canAdmin && (
              <li className="nav-item">
                <NavLink to={ROUTES.INVENTORY_ADMIN} className={navClass}>
                  Admin
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>

      <Outlet />
    </div>
  );
}

export default InventoryLayout;
